






































import Vue from "vue";
import { ref, Ref, onMounted } from "@vue/composition-api";

export default Vue.extend({
  props: {
    value: {
      type: String,
      default: "",
    },
    keepOpen: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Search...",
    },
  },
  setup(props, { emit }) {
    const isShow = ref(false);

    const root: Ref<HTMLElement | null> = ref(null);

    /**
     * @public
     * */
    const close = () => {
      if (!props.keepOpen) {
        isShow.value = false;
      }

      emit("input", "");
      emit("close", "");
    };

    const open = () => {
      if (props.disable) {
        return;
      }
      emit("onOpen");
      isShow.value = true;
      setTimeout(() => {
        const inputEl = (root.value as HTMLElement).querySelector(
          "input"
        ) as HTMLInputElement;
        inputEl && inputEl.focus();
      }, 400);
    };

    onMounted(() => {
      if (props.keepOpen) {
        isShow.value = true;
      }
    });

    return {
      isShow,
      root,
      open,
      close,
    };
  },
});
